import parse from "html-react-parser";

const Body = (props) => {
  return parse(props.content);
};

export default Body;
